/**
 * @fileoverview > handler for the "/app_settings/custom_event_property_schema" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomEventPropertySchemaCacheKeys } from "./constants";
import type {
  PostAppSettingsCustomEventPropertySchemaProps,
  AppSettingsCustomEventPropertySchemaResult,
} from "./types";

export const postAppSettingsCustomEventPropertySchema = reactQueryMutationAdapter(
  appSettingsCustomEventPropertySchemaCacheKeys,
  (props: PostAppSettingsCustomEventPropertySchemaProps): Promise<AppSettingsCustomEventPropertySchemaResult> => {
    return fetch("/app_settings/custom_event_property_schema", "POST", {
      event_name: props.eventName,
      property_name: props.propertyName,
    });
  }
);
